export { default as GDMCollapsibleMenu } from './GDMCollapsibleMenu';

export type {
  GDMCollapsibleMenuComponent,
  GDMCollapsibleMenuProps,
} from './GDMCollapsibleMenu.type';
